import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function getSessionId() {
  let id = localStorage.getItem("yt_session_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("yt_session_id", id);
  }
  return id;
}

export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  config.headers["X-Session-Id"] = getSessionId();
  return config;
});

export function errMsg(e) {
  return e?.response?.data?.detail || e?.message || "Something went wrong";
}
